
import { HEADER_MENU_ITEMS } from '../../core/components/header/models/header-menu.config';

export function getFirstAllowedRoute(roles: string[]): string {
  const firstAllowed = HEADER_MENU_ITEMS.find((item) => {
    if (!item.allowedRoles?.length) {
      return true;
    }

    return item.allowedRoles.some((role) => roles.includes(role));
  });

  return firstAllowed?.route ?? '/info';
}

export function isRouteAllowed(url: string, roles: string[]): boolean {
  const cleanUrl = url.split('?')[0].split('#')[0];

  const matchedItem = HEADER_MENU_ITEMS.find((item) => item.route === cleanUrl);

  if (!matchedItem) {
    return false;
  }

  if (!matchedItem.allowedRoles?.length) {
    return true;
  }

  return matchedItem.allowedRoles.some((role) => roles.includes(role));
}